export const TID = {
  // Landing
  navLogin: "nav-login-button",
  navRegister: "nav-register-button",
  heroGetStarted: "hero-get-started-button",
  heroSeePos: "hero-see-pos-button",

  // Auth
  loginEmail: "login-email-input",
  loginPassword: "login-password-input",
  loginSubmit: "login-submit-button",
  registerEmail: "register-email-input",
  registerName: "register-name-input",
  registerPassword: "register-password-input",
  registerSubmit: "register-submit-button",

  // Shell
  sidebar: "workspace-sidebar",
  sidebarToggle: "sidebar-toggle-button",
  topbar: "workspace-topbar",
  userMenu: "user-menu-trigger",
  userLogout: "user-menu-logout",

  // ECC
  eccDashboard: "ecc-dashboard",
  seedDemo: "seed-demo-button",

  // POS
  posTerminal: "pos-terminal",
  posCheckout: "pos-checkout-button",
  posClearCart: "pos-clear-cart-button",

  // Inventory
  inventoryAdd: "inventory-add-product",
  inventorySaveProduct: "inventory-save-product",

  // Orders
  ordersList: "orders-list",

  // DecisionOS
  decisionInput: "decision-os-input",
  decisionSend: "decision-os-send-button",
  decisionProvider: "decision-os-provider-select",

  // AI Provider config
  aiProviderKey: (p) => `ai-provider-${p}-key-input`,
  aiProviderSave: (p) => `ai-provider-${p}-save-button`,
  aiProviderTest: (p) => `ai-provider-${p}-test-button`,
};

// Legacy export referenced in default App.js — keep so build doesn't break.
export const HOME = { emergentLink: "home-emergent-link" };
